module.exports = __webpack_public_path__ + "assets/img/33.74f3856f.png";